import { useEffect, useState } from "react";
import { Box, Typography, useMediaQuery } from "@mui/material";
import UploadBox from "../../../fileUploader/UploadBox";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import UploaderLoadingComponent from "../../../uploaderComponents/UploaderLoadingComponent";
import { useDispatch } from "react-redux";
import { uploadCustomNocPDF } from "../../../../store/actions/userPackagesActions";

const UploadNocDocumentComponent = ({
  currentProcessingFile,
  setCurrentProcessingFile,
  setOnBanner,
  uploaderLoading,
  setUploaderLoading,
}) => {
  const mobileSize = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  const dispatch = useDispatch();
  const [uploadError, setUploadError] = useState(null);
  const [nextUploadAllowed, setNextUploadAllowed] = useState(false);

  const handleExtractPDF = async () => {
    const response = await dispatch(
      uploadCustomNocPDF(currentProcessingFile, setUploaderLoading)
    );
    if (!response?.success) {
      setUploadError(response?.message);
      setUploaderLoading(false);
      setNextUploadAllowed(true);
    } else {
      setOnBanner(false);
      setCurrentProcessingFile(response?.data);
    }
  };

  useEffect(() => {
    if (uploaderLoading && uploaderLoading === true) {
      handleExtractPDF();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uploaderLoading]);

  return (
    <>
      <Box
        sx={{ flexGrow: 1, overflowY: "auto", px: mobileSize ? 0 : 2, py: 2 }}
      >
        <>
          <Box mt={2}>
            {uploaderLoading ? (
              <UploaderLoadingComponent />
            ) : (
              <div style={{ position: "relative" }}>
                <UploadBox
                  setCurrentProcessingFile={setCurrentProcessingFile}
                  uploadError={uploadError}
                  nextUploadAllowed={nextUploadAllowed}
                  setUploadError={setUploadError}
                  setUploaderLoading={setUploaderLoading}
                />

                {currentProcessingFile &&
                  currentProcessingFile.document?.actions?.notarize === false &&
                  currentProcessingFile.document?.actions?.record === false && (
                    <div
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: "rgba(255,255,255,0.5)", // adjust for visibility, or use transparent
                        zIndex: 10,
                        cursor: "not-allowed",
                      }}
                    />
                  )}
              </div>
            )}

            {!uploaderLoading &&
              uploadError === "File does not appear to be a valid PDF" && (
                <Box sx={{ mt: 2 }}>
                  <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
                    <Typography variant="body2" sx={{ mr: 1 }}>
                      Why am I seeing this?
                    </Typography>
                    <HelpOutlineIcon fontSize="small" color="action" />
                  </Box>

                  <ul style={{ paddingLeft: "1.2rem", marginTop: "0.5rem" }}>
                    <li>
                      The file is not a real PDF (e.g., renamed from Word or
                      image file).
                    </li>
                    <li>
                      The PDF is damaged or has missing internal structure.
                    </li>
                    <li>
                      The file may be encrypted or generated from an unsupported
                      source.
                    </li>
                  </ul>
                </Box>
              )}
          </Box>
        </>
      </Box>
    </>
  );
};

export default UploadNocDocumentComponent;
